import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const PAGE_SIZE = 80;

export const StyledThumbnailWrapper = styled.div`
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: ${utils.rem(PAGE_SIZE)};
  outline: none;

  img {
    width: auto;
    height: ${utils.rem(PAGE_SIZE)};
    user-select: none;
  }
`;

export const StyledBadgeWrapper = styled.div`
  position: absolute;
  opacity: 0;

  ${({ theme }) => css`
    top: ${utils.rem(theme.Spacing.Size.XXSmall)};
    right: ${utils.rem(theme.Spacing.Size.XXSmall)};
    width: ${utils.rem(theme.Icon.Size.Medium)};
    height: ${utils.rem(theme.Icon.Size.Medium)};
    background: ${theme.Color.OverlayFixed.Default};
    border-radius: ${utils.rem(theme.Border.Radius.Small)};
    padding: ${utils.rem(theme.Spacing.Size.XXSmall)};
    transition: opacity ${theme.Transition.Timing.Out};
  `}
`;

export const StyledWrapper = styled.div<{
  overlay?: boolean;
  isSelected?: boolean;
  cover?: boolean;
  active?: boolean;
}>`
  position: relative;
  height: 100%;
  cursor: pointer;
  outline: none;
  ${({ theme, isSelected, active }) => css`
    ${isSelected
      ? css`
          ${StyledThumbnailWrapper}:before {
            content: '';
            position: absolute;
            top: ${utils.rem(1)};
            left: ${utils.rem(1)};
            right: ${utils.rem(1)};
            bottom: ${utils.rem(1)};
            border-radius: ${utils.rem(theme.Button.Radius.Medium)};
            box-shadow: inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)}
              ${theme.Color.Neutrals.Paper};
          }
          ${StyledThumbnailWrapper}:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: ${utils.rem(theme.Button.Radius.Medium)};
            box-shadow: inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)}
              ${theme.Color.Brand.Primary};
          }
        `
      : css`
          ${StyledThumbnailWrapper}:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: ${utils.rem(theme.Button.Radius.Medium)};
            box-shadow: inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)}
              ${theme.Color.Neutrals.Light};
          }
        `}
    ${active &&
    css`
      ${StyledThumbnailWrapper}:before {
        background-color: ${active ? theme.Color.NeutralsFixed.Light : 'transparent'};
        box-shadow: none;
      }
      ${StyledThumbnailWrapper}:after {
        background-color: ${active ? theme.Color.NeutralsFixed.Light : 'transparent'};
        box-shadow: none;
      }
    `}

    &:hover {
      transition: opacity ${theme.Transition.Timing.In};

      ${StyledBadgeWrapper} {
        opacity: 1;
      }
    }
  `}
`;

export const StyledIndicator = styled.div`
  width: ${utils.rem(2)};
  height: 100%;
  background: ${({ theme }) => theme.Color.Brand.Primary};
  position: absolute;
`;
